<wdpr-toast
  #toast
  [attr.message]="alert?.message"
  dismissable
  duration="2200"  
  headerHeight="52"
  distance="65"
  [attr.success]="alert?.type === 'success' ? '' : null">
</wdpr-toast>

